'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/object-is/polyfill.js
 ** module id = 537
 ** module chunks = 1
 **/